export const convertIdade = (dataNascimento: Date): number | string => {
  if (!dataNascimento) {
    return "Idade não disponível"; // Mensagem padrão para valores nulos ou indefinidos
  }
  const data = new Date(dataNascimento); // Converte para uma instância de Date

  if (isNaN(data.getTime())) {
    throw new Error("Data de nascimento inválida");
  }

  const dataAtual = new Date();
  const anoAtual = dataAtual.getFullYear();
  const mesAtual = dataAtual.getMonth();
  const diaAtual = dataAtual.getDate();

  const anoNascimento = data.getFullYear();
  const mesNascimento = data.getMonth();
  const diaNascimento = data.getDate();

  let idade = anoAtual - anoNascimento;

  if (
    mesAtual < mesNascimento ||
    (mesAtual === mesNascimento && diaAtual < diaNascimento)
  ) {
    idade--;
  }

  return idade;
};
